import type { HttpClient } from '../http/types';
import type {
  BackendCustomer,
  CreateBackendCustomerPayload,
  UpdateBackendCustomerPayload,
} from '../types/customer';
import { ENDPOINTS } from './endpoints';

export function createCustomersApi(http: HttpClient) {
  return {
    list: () => http.get<BackendCustomer[]>(ENDPOINTS.customers.root),
    create: (payload: CreateBackendCustomerPayload) =>
      http.post<BackendCustomer>(ENDPOINTS.customers.root, payload),
    update: (id: string, payload: UpdateBackendCustomerPayload) =>
      http.patch<BackendCustomer>(ENDPOINTS.customers.byId(id), payload),
  };
}

export type CustomersApi = ReturnType<typeof createCustomersApi>;
